// extracted by mini-css-extract-plugin
export default {"rule-label":"WorkflowRetentionRules_rule-label__NaEry","rules":"WorkflowRetentionRules_rules__oKUT1","rules-table":"WorkflowRetentionRules_rules-table__W-3L+"};